import React from 'react';
import { theme } from 'constants'
import { Scene, ActivityIndicator } from 'core'
const InitLoadScreen = () => (
  <Scene style={{alignItems:'center',justifyContent:'center', backgroundColor:theme.primary_color}}>
  <ActivityIndicator color='white' size='large'/></Scene>
);
export default InitLoadScreen



// WEBPACK FOOTER //
// ./src/components/load_screen.js